import ENV from '@/config/env'
import { LoggerInterface, LogLevel } from '@/types'

const LOG_LEVELS: Record<LogLevel, LogLevel> = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
}

class Logger implements LoggerInterface {
  private isDev: boolean

  constructor() {
    this.isDev = ENV.isDevelopment
  }

  formatMessage(level: LogLevel, message: string): string {
    const timestamp = new Date().toISOString()
    return `[${timestamp}] [${level}] ${message}`
  }

  debug(message: string, data?: unknown): void {
    if (this.isDev) {
      console.log(this.formatMessage(LOG_LEVELS.DEBUG, message), data)
    }
  }

  info(message: string, data?: unknown): void {
    console.info(this.formatMessage(LOG_LEVELS.INFO, message), data)
  }

  warn(message: string, data?: unknown): void {
    console.warn(this.formatMessage(LOG_LEVELS.WARN, message), data)
  }

  error(message: string, data?: unknown): void {
    console.error(this.formatMessage(LOG_LEVELS.ERROR, message), data)
  }
}

export default new Logger()
